import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Filtercontroller.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import useCategories from '../Admin/useCategories';

const Filtercontroller = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedGuide, setSelectedGuide] = useState('');
  const filterContainerRef = useRef(null);
  const filterButtonRef = useRef(null);
  const [price, setPrice] = useState(100); // example default value
  const { categories, loading: categoriesLoading, error: categoriesError } = useCategories();
  const navigate = useNavigate();

  // Toggle visibility
  const toggleFilter = () => setIsVisible((prev) => !prev);

  // Close filter when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterContainerRef.current &&
        !filterContainerRef.current.contains(event.target) &&
        !filterButtonRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };

  const handleGuideChange = (event) => {
    setSelectedGuide(event.target.value);
  };

  const submitFilter = () => {
    setIsVisible(false);
    const queryParams = new URLSearchParams({
      guide: selectedGuide || '',
      category: selectedCategory || '',
      price_min:0,
      price_max:price
    }).toString();
    navigate(`/allproducts?${queryParams}`);
  };

  if (categoriesLoading) return <div>Loading...</div>;
  if (categoriesError) return <div>Error loading data!</div>;

  return (
    <div id="filtercontroller">
      <div id="home">
        <Link className="link" to="/">Home</Link>
      </div>

      <div id="filter" ref={filterButtonRef}>
        <button className="btn btn-primary" onClick={toggleFilter}>Filter</button>

        {isVisible && (
          <div ref={filterContainerRef} className="filter-container shadow-lg p-3">
            <div className="filter-option">
              <label>Filter By Price</label>
              <input
                type='range'
                className='form-range'
                min="0"
                max="1000"
                step="5"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
              <div>Under ${price}</div>
            </div>
            <div className="filter-option">
              <label>Filter By Guide</label>
              <select className="form-control" value={selectedGuide} onChange={handleGuideChange}>
                <option value="">For All</option>
                <option value="her">For Her</option>
                <option value="mom">For Mom</option>
                <option value="sister">For Sister</option>
                <option value="friend">For Friend</option>
              </select>
            </div>
            <div className="filter-option">
              <label>Category</label>
              <select className="form-control" value={selectedCategory} onChange={handleCategoryChange}>
                <option value="">Select a Category</option>
                {categories.map((category) => (
                  <option key={category.category_code} value={category.category_code}>
                    {category.category_name}
                  </option>
                ))}
              </select>
            </div>
            <button className="loginsignupbutton w-100" onClick={submitFilter}>Apply</button>
            <button
              className="loginsignupbutton mt-2 w-100"
              onClick={() => {
                setSelectedCategory('');
                setIsVisible(false);
                navigate('/allproducts');
              }}
            >
              Clear All Filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Filtercontroller;
